import { Observable } from "rxjs";

export abstract class WhatsappIntegration {
 abstract sendBulkMessage(listOfCustomers:any,token:string) : Observable<any>
 abstract sendMessage(phone:any,token:string,url:string) : Observable<any>

 abstract whatsappMessageList(bussinessId:any , token:any) : Observable<any>
 abstract metaWhatsappMessageList(whatsappTemplateId:any , token:any) : Observable<any>
 abstract sendMessageWithFormData(customer: any, token: string): Observable<any>
 abstract getIntegrations(): Observable<any>
 abstract createIntegration(data: any): Observable<any> 
}